import { isNotFoundOrForbiddenError } from '@utils/error-utils';
import useFloorPlanData from 'modules/site-walk/hooks/useFloorPlanData';
import { Navigate, Outlet, useParams } from 'react-router-dom';

const FloorPlanLayout = () => {
    const { clientId, projectId, floorPlanId } = useParams();

    const floorPlanQuery = useFloorPlanData({ clientId, projectId, floorPlanId });

    if (isNotFoundOrForbiddenError(floorPlanQuery.error)) return <Navigate to="/404" replace />;

    return (
        <Outlet
            context={{
                floorPlan: floorPlanQuery?.floorPlan ?? null,
                project: floorPlanQuery?.floorPlan?.project ?? null,
                isFloorPlanQueryLoading: floorPlanQuery.isLoading,
            }}
        />
    );
};

export default FloorPlanLayout;
